import type { JSX } from 'react'
import type { IDropdownItemTypeButtonProps } from '../DropdownItemTypeButton'

import { IconSizes } from 'atoms/Icon'
import {
  DropdownItemBackgrounds,
  DropdownItemFontColors,
  DropdownItemPaddings,
} from '../../DropdownItem.h'
import { DropdownItemTypeButton } from '../DropdownItemTypeButton'

export interface IDropdownItemAccountProps extends IDropdownItemTypeButtonProps {}

export const DropdownItemAccount = ({
  title = '',
  width = '224px',
  colorDefault = DropdownItemFontColors.TEXT_ICON_SECONDARY,
  colorHovered = DropdownItemFontColors.TEXT_ICON_SECONDARY,
  colorPressed = DropdownItemFontColors.TEXT_ICON_SECONDARY,
  colorSelected = DropdownItemFontColors.TEXT_ICON_PRIMARY,
  backgroundSelectedDefault = DropdownItemBackgrounds.SURFACE_OPACITY_LIGHT_10,
  paddings = DropdownItemPaddings.SIZE_60,
  iconSize = IconSizes.mSm,
  ...rest
}: IDropdownItemAccountProps): JSX.Element => (
  <DropdownItemTypeButton
    title={title}
    colorDefault={colorDefault}
    colorHovered={colorHovered}
    colorPressed={colorPressed}
    colorSelected={colorSelected}
    backgroundSelectedDefault={backgroundSelectedDefault}
    paddings={paddings}
    width={width}
    iconSize={iconSize}
    {...rest}
  />
)
